export type ResponsiveSizeClass = "sm" | "md" | "lg" | "xl" | "2xl";
